import React, { useEffect } from 'react'
import MedalTable from './components/MedalTable'
import CountryWithFlag from './components/CountryWithFlag'

import { getStatsUrl } from 'utils/js/endpoints'
import Sidebar from './Sidebar'
import './MedalTracker.scss'

export default function MedalTracker(props) {
    const [tableData, setTableData] = React.useState([])
    const [emptyTableMessage, setEmptyTableMessage] = React.useState('Loading...')
    const defaultData = [
        {
            league_rank: null,
            name: null,
            short_name: null,
            gold: null,
            silver: null,
            bronze: null,
            total: null,
            flag_url: null,
        }
    ]
    const defaultDataList = Array.from({ length: 10 }, () => ({ ...defaultData }))

    const formatMedalsData = data => {
        return data.data.teams.map(team => {
                return {
                    ...team,
                    customLabel: CountryWithFlag(team),
                }
            }).sort((a, b) => a.league_rank - b.league_rank)
    }

    useEffect(() => {
        const { year } = props.match.params

        fetch(`${getStatsUrl()}/web_standings?league=oly&season_year=${year}`)
            .then(response => {
                return response.json()
            })
            .then(jsonResponse => {
                if (jsonResponse.data.teams.length === 0) {
                    setTableData(defaultDataList)
                }else{
                    setTableData(formatMedalsData(jsonResponse))
                    setEmptyTableMessage('No Medal Information Available.')
                }
            })
            .catch(() => {
                setEmptyTableMessage('Error: Could not load data.')
            })
    }, [])

    return (
        <div className="MedalTable__cont">
            <div className="inner_cont">
                <div className="left_col">
                    <div className="table_cont">
                        <div className="page_title_cont">
                            <h1 className="page_title">Olympic Medal Standings</h1>
                        </div>
                        <MedalTable data={tableData} emptyTableMessage={emptyTableMessage} />
                    </div>
                </div>
                <div className="right_col">
                    <Sidebar />
                </div>
            </div>
        </div>
    )
}
